import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { useNavigate } from "react-router-dom";
import {
  Button,
  Grid,
  Card,
  CardContent,
  CardHeader,
  Typography,
} from "@mui/material";
import { createConversation, fetchConversations } from "../../api/chat";
import CustomAppBar from "../../components/AppBar";

const SupportChatHome = () => {
  const [conversations, setConversations] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const load = async () => {
      const response = await fetchConversations();
      setConversations(response);
    };
    load();
  }, []);

  const handleCreate = async () => {
    try {
      const response = await createConversation();
      const { status, conversation_id, data } = response;
      if (status === "success") {
        setConversations([...conversations, data]);
        navigate(`/conversation/${conversation_id}`);
      }
    } catch (error) {
      console.error("Error creating conversation:", error);
    }
  };

  const handleConversationClick = (id) => {
    navigate(`/conversation/${id}`);
  };

  const getLatestMessage = (conversation) => {
    if (
      conversation.conversation_data.length === 0 ||
      conversation.conversation_data.length === 1
    ) {
      return "No conversation";
    }
    let latestMessage = conversation.conversation_data.slice(-1)[0];
    return latestMessage.content;
  };

  const truncateText = (text, length) => {
    return text.length > length ? `${text.substring(0, length)}...` : text;
  };

  const stripMarkdown = (text) =>
    text
      .replace(/!\[.*?\]\(.*?\)/g, "") // remove images
      .replace(/\[([^\]]+)\]\((.*?)\)/g, "$1") // convert links to just text
      .replace(/[`*_>#-]/g, "") // remove formatting characters
      .replace(/\n+/g, " ") // flatten line breaks
      .trim();

  const renderConversationPreview = (conversation) => {
    if (conversation.conversation_data.length === 1) {
      return "Start conversation now!";
    }
    const latestMessage = getLatestMessage(conversation);

    if (typeof latestMessage === "string") {
      return truncateText(stripMarkdown(latestMessage), 150);
    }

    return "Error in message";
  };

  return (
    <div>
      <Helmet>
        <title>Support Chat - Farmapp</title>
      </Helmet>
      <CustomAppBar />
      <Grid container spacing={2}>
        <Grid item mt={4} textAlign="center" xs={12}>
          <Button variant="contained" onClick={handleCreate}>
            Chat with our AI Assistant
          </Button>
        </Grid>
        <Grid item xs={12}>
          {conversations.length !== 0 && (
            <Grid container spacing={2}>
              {conversations.map((conversation) => (
                <Grid item xs={12} sm={6} md={4} key={conversation.id}>
                  <Card variant="outlined">
                    <CardHeader
                      subheader={`Created on ${new Date(
                        conversation.created_on
                      ).toLocaleDateString()}`}
                      action={
                        <Button
                          variant="outlined"
                          size="small"
                          onClick={() =>
                            handleConversationClick(conversation.id)
                          }
                        >
                          View
                        </Button>
                      }
                    />
                    <CardContent>
                      <Typography variant="body2" color="textSecondary">
                        {renderConversationPreview(conversation)}
                      </Typography>
                    </CardContent>
                  </Card>
                </Grid>
              ))}
            </Grid>
          )}
        </Grid>
      </Grid>
    </div>
  );
};

export default SupportChatHome;
